import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import Layout from "../../layouts/layout";
import CheckPaymentHistory from "./checkPaymentHistory";

export default function Index() {
  return (
    <>
      <Sidebar />
      <Header />
      <Layout>
        <CheckPaymentHistory />
      </Layout>
    </>
  );
}
